<script>

    import InfoCard from '../$components/info.card.svelte'
    import InfoField from '../$components/info.field.svelte'

    export let location = null
    export let title = null

</script>

{#if location}

    <InfoCard subtitle={ `Contacto ${ title }` }>
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Contacto" icon="fas fa-user" value={ location.contact } bold size="full" />
            <InfoField label="RFC" icon="fas fa-id-card" value={ location.rfc || 'Sin información' } />
            <InfoField label="Empresa" icon="fas fa-building" value={ location.corporate || 'Sin información' } />
            <InfoField label="Teléfono" icon="fas fa-phone" value={ location.phone } />
            <InfoField label="Email" icon="fas fa-envelope" value={ location.email } />
            {#if location.references}
                <InfoField label="Referencias" icon="fas fa-info-circle" value={ location.references } size="full" />
            {/if}
        </div>
    </InfoCard>

    <InfoCard subtitle="Dirección { title }">
        <div class="columns is-multiline is-mobile is-variable is-4 mb-0">
            <InfoField label="Código postal" icon="fas fa-map-pin" value={ location.zipcode } />
            <InfoField label="Estado" icon="fas fa-map" value={ location.state } />
            <InfoField label="Ciudad" icon="fas fa-city" value={ location.city } />
            <InfoField label="Colonia" icon="fas fa-map-marker" value={ location.colony } />
            <InfoField label="Calle" icon="fas fa-road" value={ location.street } size="full" />
            <InfoField label="Exterior" icon="fas fa-door-open" value={ location.number } />
            <InfoField label="Apartamento" icon="fas fa-layer-group" value={ location.apartment || 'Sin número' } />
        </div>
    </InfoCard>

{/if}
